const PROFESSIONAL_VISIBILITY_HINTS: Record<Professionals.Visibility, string> =
	{
		PUBLIC_SEARCH:
			'Visível em todas as páginas de agendamento para o usuário.',
		DIRECT_LINK:
			'Não visível para agendamento normal. Apenas pessoas que souberem ou tiverem o UUID desse profissional.',
	};

const PROFESSIONAL_VISIBILITY_LABELS: Record<Professionals.Visibility, string> =
	{
		PUBLIC_SEARCH: 'Público',
		DIRECT_LINK: 'Link direto',
	};

const PROFESSIONAL_VISIBILITY_OPTIONS: Array<{
	value: Professionals.Visibility;
	label: string;
	hint: string;
}> = [
	{
		value: 'PUBLIC_SEARCH',
		label: PROFESSIONAL_VISIBILITY_LABELS.PUBLIC_SEARCH,
		hint: PROFESSIONAL_VISIBILITY_HINTS.PUBLIC_SEARCH,
	},
	{
		value: 'DIRECT_LINK',
		label: PROFESSIONAL_VISIBILITY_LABELS.DIRECT_LINK,
		hint: PROFESSIONAL_VISIBILITY_HINTS.DIRECT_LINK,
	},
];

export {
	PROFESSIONAL_VISIBILITY_HINTS,
	PROFESSIONAL_VISIBILITY_LABELS,
	PROFESSIONAL_VISIBILITY_OPTIONS,
};
